import { triggerStateChangedRequest } from '~core';
import { getState } from '~src/state';
import { clearSelectionsStyles } from '~src/utils';
import { updateTextBorderColorControl } from './updateTextBorderColorControl';

export function changeTextBorderColor(hexColor) {
  const activeObject = getState('activeObject');

  // Apply to all selected texts if ActiveSelection
  if (
    activeObject &&
    activeObject.type === 'activeSelection' &&
    typeof activeObject.getObjects === 'function'
  ) {
    const texts = activeObject
      .getObjects()
      .filter((o) => o.type === 'textbox' || o.type === 'i-text');
    if (texts.length) {
      texts.forEach((t) => {
        try {
          clearSelectionsStyles(t, 'stroke');
          t.set('stroke', hexColor);
          t.set('dirty', true);
        } catch (e) {
          console.error('Failed to apply text border color to selection', e);
        }
      });
      window.canvas.renderAll();
      updateTextBorderColorControl();
      triggerStateChangedRequest();
      return;
    }
  }

  if (activeObject.isEditing) {
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      clearSelectionsStyles(activeObject, 'stroke');
      activeObject.set('stroke', hexColor);
    } else if (selectionStart === selectionEnd) {
      activeObject.set('stroke', hexColor);
    } else {
      activeObject.setSelectionStyles({
        stroke: hexColor,
      });
    }
  } else {
    clearSelectionsStyles(activeObject, 'stroke');
    activeObject.set('stroke', hexColor);
  }

  window.canvas.renderAll();
  updateTextBorderColorControl();
  triggerStateChangedRequest();
}
